module.exports = __webpack_public_path__ + "static/media/klemmeno-kalos-writer.901a807a.jpg";